<template>
  <div id="app">
    <MainNav v-show="doesHaveNav()" />
    <div class="page-container">
      <transition :name="transitionName">
        <router-view></router-view>
      </transition>
    </div>
    <modal/>
    <scroll-top-button @scrollTop="scrollTop" :class="{active: isScrollTopButtonVisible}"></scroll-top-button>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import MainNav from '@/components/UI/MainNav';
import ScrollTopButton from '@/components/ScrollTopButton';
import Modal from '@/components/Modal.vue';

export default {
  name: 'App',
  data() {
    return {
      scrollButtonVisibleAt: 300,
      isScrollTopButtonVisible: false,
      routesWithoutNav: ['/expertise/design-review', '/expertise/ui', '/expertise/ux', '/expertise/graphic-design', '/expertise/interact', '/expertise/ai'],
      scrollingElement: null,
      localTransitionName: null,
    };
  },
  // created() {
  //   this.$router.beforeEach((to, from, next) => {
  //     if (to.path.startsWith('/portfolio/')) {
  //       this.localTransitionName = 'slide-left';
  //     } else if (from.path.startsWith('/portfolio/') && to.path === '/portfolio') {
  //       this.localTransitionName = 'slide-right';
  //     } else {
  //       this.localTransitionName = null;
  //     }
  //     next();
  //   });
  // },
  created() {
    this.$router.beforeEach((to, from, next) => {
      const isFromExpertise = from.path.startsWith('/expertise');
      const isToExpertise = to.path.startsWith('/expertise');

      if (to.path.startsWith('/portfolio/')) {
        this.localTransitionName = 'slide-left';
      } else if (from.path.startsWith('/portfolio/') && to.path === '/portfolio') {
        this.localTransitionName = 'slide-right';
      } else if (isFromExpertise && isToExpertise) {
        this.localTransitionName = 'fade';
      } else {
        this.localTransitionName = null;
      }
      next();
    });
  },
  mounted() {
    this.handleScroll = this.onScroll.bind(this);
    window.addEventListener('scroll', this.handleScroll, true);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll, true);
  },
  computed: {
    ...mapGetters({
      globalTransitionName: 'ui/transitionName:get',
    }),
    transitionName() {
      return this.localTransitionName || this.globalTransitionName;
    },
  },
  watch: {
    '$route'() {
      this.isScrollTopButtonVisible = false;
      this.scrollingElement = null;
    },
  },
  methods: {
    doesHaveNav() {
      if (this.$route.path.includes('/portfolio/') || this.$route.params.id) {
        return false;
      }
      return this.routesWithoutNav.indexOf(this.$route.path) === -1;
    },
    onScroll(e) {
      const { target } = e;
      const scrollTop = target === document
        ? (window.pageYOffset || document.documentElement.scrollTop)
        : target.scrollTop;
      this.scrollingElement = target;
      const isButtonShouldBeVisible = scrollTop > this.scrollButtonVisibleAt;
      if (isButtonShouldBeVisible && !this.isScrollTopButtonVisible) {
        this.isScrollTopButtonVisible = true;
      } else if (!isButtonShouldBeVisible && this.isScrollTopButtonVisible) {
        this.isScrollTopButtonVisible = false;
      }
    },
    scrollTop() {
      if (this.scrollingElement) {
        if (this.scrollingElement === document) {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
          this.scrollingElement.scrollTo({ top: 0, behavior: 'smooth' });
        }
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    },
  },
  components: {
    MainNav,
    ScrollTopButton,
    Modal,
  },
};
</script>



// WEBPACK FOOTER //
// src/layouts/index.vue